// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from 'axios';

import axiosInstance from './axiosInstance';

/**
 * @typedef {Object} ResponseGetCollectorAccountById
 * @property {Object} data - Objeto con los datos de la cuenta recaudadora
 */

/**
 * Obtener datos de una cuenta recaudadora segun su ID
 * @param {String | Number} id - Id de la cuenta recaudadora
 * @returns {Promise<AxiosResponse<ResponseGetCollectorAccountById>>} Informacion de la cuenta
 * recaudadora
 */
const getCollectorAccountById = (id) =>
  axiosInstance.get(`/internal/admin/collector_accounts/${id}`);

export default getCollectorAccountById;
